import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  class: "mr-2 sm:mr-4 text-xl w-0.5 h-8 bg-white text-white"
}
const _hoisted_5 = {
  key: 0,
  class: "m-auto grid grid-cols-[repeat(auto-fill,_minmax(13rem,_1fr))] gap-2 sm:gap-4 py-1 sm:py-2"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "m-auto grid grid-cols-[repeat(auto-fill,_minmax(13rem,_1fr))] gap-2 sm:gap-4 py-1 sm:py-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-[13rem] w-full min-h-[calc(13rem+1.75rem)] aspect-square bg-gray-300" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "flex items-center justify-center h-full"
}
const _hoisted_11 = { class: "bg-white rounded-md py-1 sm:py-2 px-2 sm:px-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 sm:mt-4" }, null, -1)
const _hoisted_13 = { class: "mt-2 sm:mt-4 -mb-6" }

import { useRoute, useRouter } from 'vue-router';
import { createVNode, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Empty, Input, Modal, Pagination, TreeSelectProps } from 'ant-design-vue';
import {
	PlusOutlined,
	DeleteFilled,
	EditFilled,
	EyeFilled,
	StarFilled
} from '@ant-design/icons-vue';
import AdvanceFilter from '@/components/disposable/AdvanceFilter.vue';
import JAVCard from '@/components/disposable/JAVCard.vue';
import SortDropdown from '@/components/disposable/SortDropdown.vue';
import ActionButtons from '@/components/shared/ActionButtons.vue';
import { Metadata } from '@/model/api';
import { ActionButton } from '@/model/button';
import { OrderOption } from '@/model/dropdown';
import { JAV, JAVPaginationRequest } from '@/model/jav';
import LocalStorageKey from '@/model/key';
import { ActionMode, SortSequence } from '@/model/universal';
import { deleteJAV, favoriteJAV, getJAVPagination, getJAVOptions } from '@/repository/jav';
import { assignWithDetail } from '@/util/universal';

enum FilterID {
	Actresses = 'actresses',
	Genres = 'genres',
	Favorite = 'Favorite'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'JAVView',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
onMounted(async () => {
	const options = await getJAVOptions();
	if (options && filters.value) {
		const option = (value: string[], color: string, id: string) =>
			value.map((v) => {
				return {
					label: v,
					value: id + ':' + v,
					color
				};
			});
		filters.value[1].children = option(options.actresses, 'orange', FilterID.Actresses);
		filters.value[2].children = option(options.genres, 'green', FilterID.Genres);
	}
	clearInvalidFilter();
});

const sort = ref('');
const sortOptions = [
	{
		label: 'Date',
		value: 'created_at'
	},
	{
		label: 'Title',
		value: 'title'
	},
	{
		label: 'Code',
		value: 'code'
	},
	{
		label: 'Actresses',
		value: 'actresses.0'
	},
	{
		label: 'Genres',
		value: 'genres.0'
	},
	{
		label: 'Favorite',
		value: 'is_favorite'
	}
];
const orderOptions = ref<OrderOption[]>([
	{
		label: (sortBy: string) => {
			switch (sortBy) {
				case 'created_at':
					return 'First to last';
				case 'title':
				case 'code':
				case 'actresses.0':
				case 'genres.0':
					return '0-9, A-Z, a-z';
				case 'is_favorite':
					return 'Favorite last';
				default:
					return '';
			}
		},
		value: SortSequence.Ascending
	},
	{
		label: (sortBy: string) => {
			switch (sortBy) {
				case 'created_at':
					return 'Last to first';
				case 'title':
				case 'code':
				case 'actresses.0':
				case 'genres.0':
					return 'z-a, Z-A, 9-0';
				case 'is_favorite':
					return 'Favorite first';
				default:
					return '';
			}
		},
		value: SortSequence.Descending
	}
]);

const mode = ref(
	assignWithDetail<string>(
		Object.values(ActionMode),
		ActionMode.View,
		localStorage.getItem(LocalStorageKey.JAVAction)
	)
);
const actions: ActionButton[][] = [
	[
		{
			tooltip: 'View',
			mode: ActionMode.View,
			component: EyeFilled,
			activeClass: 'bg-pink-400 !text-black',
			hoverClass: 'hover:bg-pink-400 hover:!text-black',
			action: () => (mode.value = ActionMode.View)
		},
		{
			tooltip: 'Favorite',
			mode: ActionMode.Favorite,
			component: StarFilled,
			activeClass: 'bg-yellow-400 !text-red-600',
			hoverClass: 'hover:bg-yellow-400 hover:!text-red-600',
			action: () => (mode.value = ActionMode.Favorite)
		}
	],
	[
		{
			tooltip: 'Add',
			mode: ActionMode.Add,
			component: PlusOutlined,
			activeClass: 'bg-green-300 !text-black',
			hoverClass: 'hover:bg-green-300 hover:!text-black',
			action: () => router.push({ name: 'Create JAV' })
		},
		{
			tooltip: 'Edit',
			mode: ActionMode.Edit,
			component: EditFilled,
			activeClass: 'bg-blue-400 !text-white',
			hoverClass: 'hover:bg-blue-400 hover:!text-white',
			action: () => (mode.value = ActionMode.Edit)
		},
		{
			tooltip: 'Delete',
			mode: ActionMode.Delete,
			component: DeleteFilled,
			activeClass: 'bg-red-500 !text-white',
			hoverClass: 'hover:bg-red-500 hover:!text-white',
			action: () => (mode.value = ActionMode.Delete)
		}
	]
];

// Advance Filter
const filterBy = ref<string[]>(
	(() => {
		const actresses =
			route.query.actresses
				?.toString()
				.split(',')
				.map((actress) => FilterID.Actresses + ':' + actress) || [];
		const genres =
			route.query.genres
				?.toString()
				.split(',')
				.map((genre) => FilterID.Genres + ':' + genre) || [];
		const isFavorite = route.query.isFavorite ? [FilterID.Favorite] : [];
		return [...isFavorite, ...actresses, ...genres];
	})()
);
const filters = ref<TreeSelectProps['treeData']>([
	{
		label: 'Favorite',
		value: 'Favorite',
		color: 'yellow'
	},
	{
		label: 'Actresses',
		value: 'Actresses',
		color: 'pink',
		children: []
	},
	{
		label: 'Genres',
		value: 'Genres',
		color: 'green',
		children: []
	}
]);
function clearInvalidFilter() {
	if (filterBy.value && filters.value) {
		let allFilters: string[] = [];
		filters.value.forEach((filter) => {
			if (filter.children) {
				allFilters.push(...filter.children.map((f) => f.value as string));
			} else {
				allFilters.push(filter.value);
			}
		});
		filterBy.value = filterBy.value.filter((filter) => allFilters.includes(filter));
	}
}

// Specific Data
let jav = ref<JAV[]>([]);
const isFetching = ref(true);
const search = ref(route.query.search?.toString() || '');
const metadata = ref<Metadata>(initialMetadata());
function initialMetadata(): Metadata {
	return {
		limit: Number(route.query.limit) || 10,
		offset: 0,
		totalItem: 0,
		totalPage: 0,
		currentPage: Number(route.query.page) || 1
	};
}

function filter(field: string) {
	if (field === FilterID.Favorite) {
		return filterBy.value.findIndex((filter) => filter === FilterID.Favorite) !== -1
			? FilterID.Favorite
			: '';
	}
	const filterValues = filterBy.value.filter((f) => f !== FilterID.Favorite);
	const filterByField =
		filters.value
			?.find((filter) => filter.label.toLowerCase() === field)
			?.children?.map((v) => v.value) || [];
	return filterByField
		.filter((filter) => filterValues.includes(filter))
		.map((filter) => filter.substring(filter.indexOf(':') + 1))
		.join(',');
}

async function fetchData() {
	const advanceFilter = {
		actresses: filter(FilterID.Actresses) || undefined,
		genres: filter(FilterID.Genres) || undefined,
		isFavorite: filter(FilterID.Favorite).length > 0 || undefined
	};
	const query: JAVPaginationRequest = {
		page: metadata.value.currentPage,
		offset: metadata.value.offset,
		limit: metadata.value.limit,
		sort: sort.value,
		search: search.value,
		actresses: advanceFilter.actresses,
		genres: advanceFilter.genres,
		isFavorite: advanceFilter.isFavorite
	};
	router.replace({
		query: {
			page: metadata.value.currentPage,
			limit: metadata.value.limit,
			search: search.value || undefined,
			sort:
				sortOptions
					.find((s) => s.value.toLowerCase() === sort.value.split(' ')[0].toLowerCase())
					?.label?.toLowerCase() || undefined,
			order: sort.value.split(' ')[1] || undefined,
			actresses: advanceFilter.actresses,
			genres: advanceFilter.genres,
			isFavorite: advanceFilter.isFavorite ? 'true' : undefined
		}
	});
	try {
		isFetching.value = true;
		const data = await getJAVPagination(query);
		if (data) {
			isFetching.value = false;
			jav.value = data.data;
			metadata.value = data.metadata;
			if (metadata.value.totalPage > 0 && (!data.data || !data.data.length)) {
				metadata.value.currentPage = metadata.value.totalPage;
			}
		}
	} catch (error) {
		store.dispatch('alert', { type: 'error', message: 'something went wrong, please try again!' });
	}
}

async function clickCard(javData: JAV) {
	switch (mode.value) {
		case ActionMode.View:
			window.open(javData.link, '_blank');
			return;

		case ActionMode.Favorite:
			javData.isFavorite = !javData.isFavorite;
			await favoriteJAV(javData.javUUID as string, javData.isFavorite);
			return;

		case ActionMode.Edit:
			router.push({ path: '/jav/update/' + javData.javUUID });
			return;

		case ActionMode.Delete:
			Modal.confirm({
				title: 'Delete JAV',
				icon: createVNode(DeleteFilled),
				content: 'Do you want to delete this jav right?',
				okText: 'Yes',
				cancelText: 'No',
				async onOk() {
					if (javData.javUUID) {
						await deleteJAV(javData.javUUID);
						await fetchData();
					}
				}
			});
			return;
	}
}

watch(mode, () => localStorage.setItem(LocalStorageKey.JAVAction, mode.value));
watch(
	() => metadata.value.currentPage,
	async () => (metadata?.value.currentPage !== 0 ? await fetchData() : {})
);
watch(() => metadata.value.limit, fetchData);
watch(() => filterBy.value, fetchData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SortDropdown, {
        sortOptions: sortOptions,
        orderOptions: orderOptions.value,
        defaultSortBy: sortOptions[0].value,
        defaultOrderBy: orderOptions.value[1].value,
        onSort: _cache[0] || (_cache[0] = (value) => (sort.value = value)),
        onChange: fetchData
      }, null, 8, ["orderOptions", "defaultSortBy", "defaultOrderBy"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (buttons, index) => {
          return _createElementVNode("div", {
            key: index,
            class: "flex items-center gap-2 sm:gap-4 my-2 sm:my-4"
          }, [
            _createVNode(ActionButtons, {
              actions: buttons,
              mode: mode.value,
              placement: 
							(buttonIndex) =>
								index === actions.length - 1 && buttonIndex === buttons.length - 1
									? 'topRight'
									: !index && !buttonIndex
										? 'topLeft'
										: 'top'
						
            }, null, 8, ["actions", "mode", "placement"]),
            (index !== actions.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true)
          ])
        }), 64))
      ])
    ]),
    _createVNode(_unref(Input).Search, {
      value: search.value,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
      placeholder: "Search jav title ...",
      "enter-button": "",
      "allow-clear": "",
      onSearch: _cache[2] || (_cache[2] = ($event: any) => (fetchData()))
    }, null, 8, ["value"]),
    _createElementVNode("div", {
      class: _normalizeClass(
				'py-1 sm:py-2 ' +
				(isFetching.value || _unref(jav)?.length
					? 'min-h-[calc(100vh-80px-208px)] max-[575px]:min-h-[calc(100vh-80px-248px)] sm:min-h-[calc(100vh-80px-264px)]'
					: 'h-[calc(100vh-80px-208px)] max-[575px]:h-[calc(100vh-80px-248px)] sm:h-[calc(100vh-80px-264px)]')
			)
    }, [
      (!isFetching.value && _unref(jav)?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jav), (data, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                href: data.link,
                onclick: "return false"
              }, [
                _createVNode(JAVCard, {
                  jav: data,
                  onClick: clickCard
                }, null, 8, ["jav"])
              ], 8, _hoisted_6))
            }), 128))
          ]))
        : (isFetching.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(metadata.value.limit), (_, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "rounded-md shadow-md bg-white overflow-hidden animate-pulse"
                }, _hoisted_9))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(Empty))
            ]))
    ], 2),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(Pagination), {
        current: metadata.value.currentPage,
        "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((metadata.value.currentPage) = $event)),
        "page-size": metadata.value.limit,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((metadata.value.limit) = $event)),
        total: metadata.value.totalItem,
        "show-total": (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        "show-size-changer": "",
        "show-quick-jumper": "",
        onChange: _cache[5] || (_cache[5] = 
					(page, pageSize) => {
						metadata.value.currentPage = page;
						metadata.value.limit = pageSize;
					}
				)
      }, null, 8, ["current", "page-size", "total", "show-total"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(AdvanceFilter, {
        filterBy: filterBy.value,
        filters: filters.value,
        favoriteID: FilterID.Favorite,
        filterIDs: Object.values(FilterID),
        onFilter: _cache[6] || (_cache[6] = (filter) => (filterBy.value = filter))
      }, null, 8, ["filterBy", "filters", "favoriteID", "filterIDs"])
    ])
  ]))
}
}

})